
//View Form Data
const fieldAffViewBasic = [
    {label: "First Name", type: "string", value_key: "first_name"},
    {label: "Last Name", type: "string", value_key: "last_name"},
    {label: "Email", type: "string", value_key: "email"},
    {label: "Mobile", type: "string", value_key: "mobile_number"},
    {label: "Country", type: "string", value_key: "country"},
    {label: "State", type: "string", value_key: "state"},
    {label: "City", type: "string", value_key: "city"},
    {label: "PAN Number", type: "string", value_key: "pan"},
    {label: "GST Number", type: "string", value_key: "gst"}
];

const fieldAffViewType = [
    {label: "Affiliate Type", type: "object", value_key: "type_details.label"}
];

const fieldAffViewChannel = [
    {label: "Website Blog URL", type: "string", value_key: "website"},
    {label: "Social Media Handles", type: "string", value_key: "social_handle"},
    {label: "Follower/Subscriber Count", type: "string", value_key: "follower_count"},
    {label: "Average Monthly Student Reach", type: "string", value_key: "stu_reach"}
];

const fieldAffViewPlan = [
    {label: "Marketing Plans", type: "array", value_key: "plan_details", array_key: "label"},
    {label: "Have you promoted digital products before?", type: "string", value_key: "prev_promoted"},
    {label: "Promoted digital products, which ones?", type: "string", value_key: "promoted_product"},
    {label: "What is your monthly target with PORT?", type: "string", value_key: "monthly_target"}
];

const fieldAffViewBank = [
    {label: "Bank Account Holder Name", type: "string", value_key: "holder_name"},
    {label: "Bank Account Number", type: "string", value_key: "account_number"},
    {label: "IFSC Code", type: "string", value_key: "ifsc_code"},
    {label: "UPI ID", type: "string", value_key: "upi_id"}
];

const data = {
    fieldAffViewBasic,
    fieldAffViewType,
    fieldAffViewChannel,
    fieldAffViewPlan,
    fieldAffViewBank
};
  
export default data;